/**
 * 操作记录接口
 * date:2022 04 01
 */
import httpRequest from '@/utils/request.js';

export const operateList = (params = {}, way) => httpRequest.httpGet({
    url: '/service/carrier/operate/list/' + way, params: {
        ...params
    }
});
/** 查看详细 */
export const operateDetail = (id, way) => httpRequest.httpGet({
    url: '/service/carrier/operate/detail/' + way + '/' + id
});
/**操作记录删除 */
export const operateDelete = (data, way) => httpRequest.httpdelete('/service/carrier/operate/delete/' + way, data);